import { useEffect, useState } from 'react';

export const usePaymentCountdown = payment => {
  const [seconds, setSeconds] = useState(0);
  useEffect(() => {
    if (!payment) { setSeconds(0); return; }
    const duration = Date.parse(payment.expiresAt) - Date.parse(payment.serverTime);
    const observed = performance.now();
    const tick = () => setSeconds(Math.max(0, Math.ceil((duration - (performance.now() - observed)) / 1000)));
    tick();
    const timer = setInterval(tick, 250);
    return () => clearInterval(timer);
  }, [payment]);
  return { seconds, display: `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}` };
};